import React from 'react';
import PropTypes from 'prop-types';

import MiddleDot from 'dpl/breeder_dashboard/payments/components/MiddleDot';

export default function PaymentMethod({
  paymentMethod,
  shouldShowActiveLabel,
  className,
  style,
  onClick
}) {
  const {
    account_holder: accountHolder,
    brand_name: brandName,
    last4,
    funding,
    account_type: accountType
  } = paymentMethod;

  return (
    <button
      type="button"
      className={`PaymentMethod w-100 ba bg-white br4 b--light-gray pv6 ph8-ns ph6 flex-auto ${className}`}
      style={style}
      disabled={!onClick}
      aria-disabled={!onClick}
      onClick={onClick}
    >
      <span className="mb1 flex items-center justify-between">
        <span className="ttc">
          <span>
            {brandName}
            {funding && (
              <>
                {' '}
                <MiddleDot /> {funding}
              </>
            )}
            {accountType && ` ${accountType.split('_').join(' ')}`}
          </span>
          <br />
          <span>
            {accountHolder && `${accountHolder}, `}
            <MiddleDot />
            <MiddleDot />
            <MiddleDot />
            <MiddleDot />
            {last4}
          </span>
        </span>
        {shouldShowActiveLabel && <p className="green f2 fw-medium">Active</p>}
      </span>
    </button>
  );
}

PaymentMethod.propTypes = {
  paymentMethod: PropTypes.shape({
    brand_name: PropTypes.string.isRequired,
    last4: PropTypes.string.isRequired,
    account_holder: PropTypes.string,
    account_type: PropTypes.string,
    funding: PropTypes.string
  }).isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  shouldShowActiveLabel: PropTypes.bool
};

PaymentMethod.defaultProps = {
  className: '',
  onClick: null,
  shouldShowActiveLabel: true,
  style: {}
};
